import type { ReferenceEntity } from './types';

export const STEP_LABELS = [
  'Planilha',
  'Pré-visualização',
  'Correspondência de dados',
  'Importação',
];

export const ENTITY_ORDER: ReferenceEntity[] = [
  'carrier',
  'warehouse',
  'vehicle_type',
  'operation_type',
  'company',
];

export const ENTITY_LABELS: Record<ReferenceEntity, string> = {
  carrier: 'Transportadora',
  warehouse: 'Armazéns',
  vehicle_type: 'Tipo de Veículo',
  operation_type: 'Operação',
  company: 'Tomador / Empresas',
};
